export class Token {
  token: string;
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/app/infrastructure/models/token.ts